import React from 'react';
import { connect } from 'react-redux';

import { UserSearch } from 'ha/services/apiV2/types/UserSearch';
import {
  getSavedSearches,
  getIsLoaded,
  getIsLoading,
  RootState,
} from '../reducer';
import loadSavedSearches from '../actions/loadSavedSearches';

interface ChildrenFn {
  items: UserSearch[];
  isLoaded: boolean;
  isLoading: boolean;
}

interface StateProps {
  items: UserSearch[];
  isLoaded: boolean;
  isLoading: boolean;
}

interface DispatchProps {
  load: (id: number, query: { language: string }) => Promise<void>;
}

interface Props {
  children: (args: ChildrenFn) => React.ReactNode;
  userId: number;
  language: string;
}

export class SavedSearches extends React.Component<
  Props & StateProps & DispatchProps
> {
  componentDidMount = () => {
    const { isLoaded, isLoading, load, userId, language } = this.props;

    if (!isLoaded && !isLoading) {
      load(userId, { language });
    }
  };

  render() {
    const { children, items, isLoaded, isLoading } = this.props;

    return children({
      items,
      isLoaded,
      isLoading,
    });
  }
}

export default connect<StateProps, {}>(
  (state: RootState) => ({
    items: getSavedSearches(state),
    isLoaded: getIsLoaded(state),
    isLoading: getIsLoading(state),
  }),
  {
    load: loadSavedSearches,
  },
)(SavedSearches);
